import React from 'react';
import { Filter } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '../ui/sheet';
import { Switch } from '../ui/switch';

export default function AdvancedFiltersPanel({ filters, onFilterChange, onClear }) {
  const activeFilterCount = (filters.status !== 'all' ? 1 : 0) + (filters.search ? 1 : 0) + (filters.discount ? 1 : 0);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="sm" className="ml-auto gap-2">
          <Filter className="h-3.5 w-3.5" /> Filter
          {activeFilterCount > 0 ? (
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary text-[10px] text-primary-foreground">
              {activeFilterCount}
            </span>
          ) : null}
        </Button>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Erweiterte Filter</SheetTitle>
          <SheetDescription>Verfeinere die Reservierungsansicht fuer den aktuellen Zeitraum.</SheetDescription>
        </SheetHeader>

        <div className="grid gap-6 py-6">
          <div className="space-y-2">
            <Label htmlFor="reservations-search-filter">Gast suchen</Label>
            <Input
              id="reservations-search-filter"
              placeholder="Name, E-Mail oder Telefon"
              value={filters.search}
              onChange={(event) => onFilterChange('search', event.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="reservations-status-filter">Status</Label>
            <Select value={filters.status} onValueChange={(value) => onFilterChange('status', value)}>
              <SelectTrigger id="reservations-status-filter">
                <SelectValue placeholder="Status waehlen" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alle</SelectItem>
                <SelectItem value="upcoming">Aktiv</SelectItem>
                <SelectItem value="pending">Offen</SelectItem>
                <SelectItem value="confirmed">Bestaetigt</SelectItem>
                <SelectItem value="seated">Anwesend</SelectItem>
                <SelectItem value="completed">Abgeschlossen</SelectItem>
                <SelectItem value="cancelled">Storniert</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-between rounded-lg border p-3">
            <div className="space-y-0.5">
              <Label htmlFor="discount-only-filter" className="text-base">Nur Rabatte</Label>
              <p className="text-xs text-muted-foreground">Zeigt nur Reservierungen mit erkanntem Rabatt.</p>
            </div>
            <Switch
              id="discount-only-filter"
              checked={filters.discount}
              onCheckedChange={(checked) => onFilterChange('discount', checked)}
            />
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2">
          <Button variant="outline" onClick={onClear}>Alle Filter zuruecksetzen</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
